import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// Custom validator to check minimum trimmed length
export function minTrimmedLengthValidator(minLength: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value =
      typeof control.value === 'object'
        ? control.value?.target?.value
        : control.value;

    if (typeof value !== 'string') {
      return null; // ignore non-string values
    }

    const trimmedValue = value.trim();
    if (trimmedValue.length < minLength) {
      return {
        minTrimmedLength: {
          requiredLength: minLength,
          actualLength: trimmedValue.length,
        },
      };
    }

    return null;
  };
}
